function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1890",
    d: "m-5.269-9 5.049-5.049a.749.749 0 0 0 0-1.058l-1.173-1.173a.749.749 0 0 0-1.058 0L-7.5-11.231l-5.049-5.049a.749.749 0 0 0-1.058 0l-1.173 1.173a.749.749 0 0 0 0 1.058L-9.731-9l-5.049 5.049a.749.749 0 0 0 0 1.058l1.173 1.173a.749.749 0 0 0 1.058 0L-7.5-6.769l5.049 5.049a.749.749 0 0 0 1.058 0l1.174-1.173a.749.749 0 0 0 0-1.058z",
    transform: "translate(15 16.5)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/close-white-icon.7e7ec514.svg";
export { ForwardRef as ReactComponent };